<!-- 单数据显示组件 -->
<template>
  <div @click="clickSingleOutputCmp(componentIndex)"
       @dragover="allowSingleBind"
       @drop="(event) => dragToSingleOutputCmp(event, itemData, componentIndex)"
       class="single-output">
    <el-input v-model="itemData.name" placeholder="请输入内容" class="title" :disabled="getCurCmpStatus"
              @change="saveAllCpt"></el-input>
    <div class="cmp-handle">
      <el-dropdown>
          <span class="el-dropdown-link">
            <i class="el-input__icon el-icon-more"></i>
          </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            @click.native="handleCmp('delete', itemData, componentIndex)">删除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <a>
      <el-table :data.sync="uDataSources" border class="table">
        <el-table-column
          align="center"
          label="数据名称"
          min-width="100"
          prop="text">
          <template slot-scope="scope">
            <span :title="scope.row.text"
                  @dblclick="(event)=>dbClick(event,scope.row.key)" class="name-wrapper"
                  slot="reference"
                  style="white-space: nowrap;cursor:pointer;">{{scope.row.text}}</span>
          </template>
        </el-table-column>
        <el-table-column align="center"
                         label="值"
                         min-width="50"
                         prop="value">
        </el-table-column>
        <el-table-column
          align="center"
          label="操作"
          min-width="20">
          <template slot-scope="scope">
            <el-button @click="deleteDataSourceItem(scope.row)" icon="el-icon-delete" style="color: #222222"
                       type="text"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </a>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';

export default {
  name: 'single-output',
  data() {
    return {
      uDataSources: [],
    };
  },
  components: {},
  props: {
    itemData: {
      type: Object,
      default() {
        return [];
      },
    },
    // 当前组件的index
    componentIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState('Engineering', ['dragTreeNodeType', 'dragTreeNodeKey']),
    ...mapGetters('Engineering', ['getCurCmpStatus']),
    chartData() {
      return this.itemData.chartData || [];
    },
    dataSou() {
      return this.itemData.dataSources || [];
    },
  },
  watch: {
    dataSou: {
      handler(newDataSou) {
        const self = this;
        self.uDataSources = newDataSou.map(item => ({
          text: item.text,
          key: item.key,
          value: 0,
          unit: item.unit,
        }));
      },
      deep: true,
      immediate: true,
    },
    chartData: {
      handler(newChartData = []) {
        const self = this;
        const { uDataSources } = this;
        if (newChartData.length > 0) {
          newChartData.forEach((item) => {
            const index = uDataSources.findIndex(item2 => item2.key === item.key);
            if (index > -1) {
              self.uDataSources[index].value = item.values[0].value;
            }
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
  },
  methods: {
    ...mapState('Engineering', ['leftStructure']),
    ...mapMutations('Engineering', [
      'clickComponent',
      'addSignalToSingleOutput',
      'deleteComponent',
      'deleteSingleOutputDataSources',
      'setAnchorPointId',
      'setAnchorKeyWord']),
    ...mapActions('Engineering', ['setBindValue', 'deleteCpt', 'saveAllCpt']),
    dbClick(event, key) {
      event.stopPropagation();
      const arr = key.split('.');
      const str = arr.join('');
      const arr2 = str.split(':');
      const str2 = arr2.join('');
      this.setAnchorKeyWord(key.substring(key.lastIndexOf('.') + 1)); // 信号名
      setTimeout(() => {
        this.setAnchorKeyWord('');
        this.setAnchorPointId('');
        setTimeout(() => {
          this.setAnchorPointId(str2);
        }, 50);
      }, 50);
    },
    /**
       * 删除数据源
       * @param rowData
       */
    deleteDataSourceItem(rowData) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      console.log(rowData);
      const { componentIndex } = this;
      this.$store.commit('Engineering/deleteDataSource', {
        cptIndex: componentIndex,
        dataSourceKey: rowData.key,
      });
      // const
    },
    handleCmp(command, component, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({
            index,
          });
          break;
        default:
          break;
      }
    },
    dragToSingleOutputCmp(event, item, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const isExistIndex = this.uDataSources.findIndex(item2 => item2.key === this.dragTreeNodeKey);
      if (isExistIndex > -1) {
        this.$message({
          message: '无法拖拽重复的节点',
        });
        return;
      }

      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      this.addSignalToSingleOutput({ dragNode, componentIndex });
    },
    allowSingleBind(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL || this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE
          || this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_MSG) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    clickSingleOutputCmp(index) {
    },
  },
};

</script>

<style lang="scss" scoped>
  @import "../../style/mixin";

  .single-output {
    width: 100%;
    height: 100%;
    padding: 10px;
    position: relative;
    overflow: hidden;

    .cmp-handle {
      position: absolute;
      top: 0;
      right: 0;

      .el-input__icon {
        line-height: 25px;
      }
    }

    .table {
      width: 100%;
      height: 90%;
      overflow: auto;
      @include hide-scroll-bar;
    }

    // 去除多余的横线
    .el-table::before {
      height: 0;
    }

    .title {
      font-size: 14px;
      font-weight: bold;
      width: 50%;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/SingleOutput.vue